import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Link from "next/link";
import Image from "next/image";

import carouselBGimg01 from "../../assets/images/home/Banner/UPSC-Result-Web-Banner.jpg";
import carouselBGimg2 from "../../assets/images/home/Banner/UPSC-State-topper-2024-Web-Banner.jpg";
import carouselBGimg1 from "../../assets/images/home/Banner/UPSC-CSE-2025-Webbanner.jpg";
import carouselBGimg3 from "../../assets/images/home/Banner/All-India-Mocktest-Web-Banner-Click-Here.jpg";
import carouselBGimg5 from "../../assets/images/home/Banner/Toppers-Web-Banner-Click-Here.jpg";
import carouselBGimg6 from "../../assets/images/home/Banner/TNPSC-RESULT-Web-Banner-02-1-2025.jpg";
import carouselBGimg7 from "../../assets/images/home/Banner/TNPSC-PCM-Webbanner-ClickHere.jpg";
import carouselBGimg8 from "../../assets/images/home/Banner/Felicitation -web-banner-button.jpg";
import carouselBGimg9 from "../../assets/images/home/Banner/IFS-Result-Webbanner-2024.jpg";
import carouselBGimg10 from "../../assets/images/home/Banner/TNPSC-Group-II-and-IIa-Mock-test-Web-Banner-Clickhere.jpg";


{/* mobile */}
import carouselMBimg01 from "../../assets/images/home/Mob_Banner/Achivers-2026-Web-Banner.webp";
import carouselMBimg2 from "../../assets/images/home/Mob_Banner/UPSC-Moct-test-Web-Banner-Clikbutton-26.webp";
import carouselMBimg02 from "../../assets/images/home/Mob_Banner/Pre-Prefit-Web-Banner.webp";
import carouselMBimg03 from "../../assets/images/home/Mob_Banner/Tnpsc-Achivers-Web-Banner.webp";
import carouselMBimg04 from "../../assets/images/home/Mob_Banner/Feliciation-Web-Banner.webp";

function slider() {

    const BGimg = [
     { quickLoading: false, img: carouselMBimg01, alt: "carousel", link: "/upsc-admission-anna-nagar" },
     { quickLoading: false, img: carouselMBimg03, alt: "carousel", link: "/tnpsc-admissions" },
     { quickLoading: false, img: carouselMBimg2, alt: "carousel", link: "/upsc-admission-anna-nagar" },
     { quickLoading: false, img: carouselMBimg02, alt: "carousel", link: "/upsc-admission-anna-nagar" },
     { quickLoading: false, img: carouselMBimg04, alt: "carousel", link: "/upsc-admission-anna-nagar" }, 
 
    ]
    
    const MBimg = [
        { quickLoading: false, img: carouselMBimg01, alt: "carousel", link: "/upsc-admission-anna-nagar" },
        { quickLoading: false, img: carouselMBimg2, alt: "carousel", link: "/upsc-admission-anna-nagar" },

      ]
  
  return (
    <>
        {/* Carousel large devices*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0 d-none d-md-block">
            <Carousel>
              {BGimg.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage img-fluid w-100 h-100"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      loading={e.quickLoading ? "eager" : "lazy"}
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

      {/* Carousel Mobile devices*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0 d-block d-md-none">
            <Carousel>
              {MBimg.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                    className="carouselimage"
                    src={e.img}
                    alt={e.alt}
                    title="Shankar IAS Academy"
                    loading={e.quickLoading ? "eager" : "lazy"}
                    placeholder="blur"
                    width={800}     // give original image size
                    height={400}    // any aspect ratio
                    style={{ width: "100%", height: "auto" }}
                  /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

    </>
  )
}

export default slider